import { MixinFactory, State } from '@stencil/core';
import { reduceMotion } from '@/index';

export const animateHeightFactory: MixinFactory = Base => {
  class A extends Base {
    private animation: Animation;

    private animationDurationDefault: number = 400;
    private animationDuration: number = this.animationDurationDefault;

    @State() private isClosing: boolean = false;
    @State() private isExpanding: boolean = false;

    private animateDropdown(element: HTMLElement, open: boolean, startHeight: string, endHeight: string) {
      this.cancelAnimations();

      if (reduceMotion()) this.animationDuration = 0;
      else this.animationDuration = this.animationDurationDefault;

      element.dataset.moving = '';

      this.animation = element.animate(
        {
          height: [startHeight, endHeight],
        },
        {
          duration: this.animationDuration,
          easing: 'cubic-bezier(0.6, 0, 0.2, 1)',
        },
      );
      this.animation.onfinish = () => this.animationFinish(element);
      this.animation.oncancel = () => (open ? (this.isExpanding = false) : (this.isClosing = false));
    }

    openDropdown(element: HTMLElement) {
      const { clientHeight, scrollHeight } = element;
      const height = this.isClosing ? clientHeight : 0;
      element.style.height = `${scrollHeight}px`;

      this.isExpanding = true;
      this.animateDropdown(element, true, `${height}px`, `${element.scrollHeight}px`);
    }

    closeDropdown(element: HTMLElement) {
      const { scrollHeight, clientHeight } = element;
      const height = this.isExpanding ? clientHeight : scrollHeight;
      element.style.height = `0px`;

      this.isClosing = true;
      this.animateDropdown(element, false, `${height}px`, `0px`);
    }

    private animationFinish(element: HTMLElement) {
      this.cancelAnimations();
      element.style.height = this.isClosing ? '0px' : '';
      delete element.dataset.moving;
      this.isClosing = false;
      this.isExpanding = false;
    }

    private cancelAnimations() {
      if (this.animation) this.animation.cancel();
    }

    isMoving(): boolean {
      return this.isClosing || this.isExpanding;
    }
  }
  return A;
};
